<section class="esn-faq-group">
  @if (heading()) {
    <h2 class="esn-faq-group__heading">{{ heading() }}</h2>
  }
  <div class="esn-faq-group__questions">
    @for (item of items(); track item.id; let first = $first) {
      <esn-faq-item
        [question]="item.question"
        [answer]="item.answer"
        [divider]="!first"
        [open]="isOpen(item.id)"
        (openChange)="setOpen(item.id, $event)"
      />
    }
  </div>
</section>
